import { useContext, createContext } from 'react';
import noop from 'utils/noop';

export type BranchFocusState = {
  activeBranch: string;
  setActiveBranch: (activeBranch: string) => void;
  showBranchFocus: boolean;
};

export const BranchFocusContext = createContext<BranchFocusState>({
  activeBranch: '',
  setActiveBranch: noop,
  showBranchFocus: false,
});

export const useBranchFocusContext = () => useContext(BranchFocusContext);
